module.exports = __webpack_public_path__ + "static/media/mobile.fd03e2c6.svg";